import React from 'react';

import { Badge } from '../Badge';

import { SpreadProps } from './types';
import { Component } from './styles';

export const Spread = React.memo<SpreadProps>(({ value }) => {
  return (
    <Component>
      <Badge color="blue">{value}%</Badge>
    </Component>
  );
});
